import React from "react";
import { Outlet } from "react-router-dom";
import { useAppContext } from "../../app/AppRootProviders";
// import { AppProviders } from "./AppProviders";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { TooltipProvider } from "../../components/tooltip";

interface DashboardLayoutProps {
  user?: { email?: string; profile_image_url?: string };
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ user }) => {
  const { sidebarOpen, setSidebarOpen, onLogout } = useAppContext();

  return (
    <div id="dashboard-layout" className="bg-muted/50 flex h-screen overflow-hidden">
      {/* Sidebar */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onLogout={onLogout} />

      {/* Main content */}
      <div className="flex-1 flex flex-col min-w-0 bg-white dark:bg-gray-900 overflow-y-auto">
        {/* Topbar */}
        <Topbar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} onLogout={onLogout} user={user} />

        {/* Content */}
        <main className="flex-1 max-h-[calc(100vh-64px)] overflow-y-auto ">
          <TooltipProvider>
            <Outlet />
          </TooltipProvider>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
